/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './LabeledIcon.scss';

import { string } from 'prop-types';
import React from 'react';

const LabeledIcon = ({ icon: Icon, label }) => (
  <div className="labeled-icon-container">
    <Icon className="icon" />
    {label}
  </div>
);

LabeledIcon.propTypes = {
  label: string.isRequired
};

export default LabeledIcon;
